<template>
  <span>
    <span v-if="value">
      <template v-if="value.toLowerCase() == 'updating'">
        <img src="/img/Spinner-1s-30px.gif" />
      </template>
      <template v-else>
        <span :title="'Heater: ' + value">
          <v-icon
            v-if="disabled"
            :size="iconSize"
            :color="heaterstripstateColors[value.toLowerCase()]"
          >
            waves
          </v-icon>
          <v-icon
            v-else
            :size="iconSize"
            color="rgb(192, 192, 192)"
          >
            waves
          </v-icon>
        </span>
      </template>
    </span>
  </span>
</template>

<script>
export default {
  name: "",
  props: ["value", "onclick", "iconSize", "disabled"],
  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {
      heaterstripstateColors: {
        off: "grey",
        on: "orange"
      }
    };
  },

  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="scss"></style>
